function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 214.729C32 183.399 59.187 158 92.723 158h46.554C172.813 158 200 183.399 200 214.729V232H32v-17.271z",
  fill: "#D0F4FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M164 163c20.495 2.277 36 19.601 36 40.222V232h-36v-69zm-95-.5c-21.12 2.569-37 20.497-37 41.773V232h37v-69.5zm49.716 49.976l17.715-46.703c1.241-3.271-1.176-6.773-4.675-6.773H98.721c-3.625 0-6.046 3.737-4.563 7.045l20.863 46.54c.729 1.627 3.062 1.559 3.695-.109z",
  fill: "#72AEFF"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 116,
  cy: 161,
  rx: 28,
  ry: 12,
  fill: "#747FDD"
});

function SvgClothes6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "static/media/clothes-6.440bb83d.svg";
export { SvgClothes6 as ReactComponent };